export const environment = {
  production: false,
  baseUrl: 'https://backend.demo.figalaxy.com/api',
  stripeKey:
    'pk_test_51MmE4vFWAGI2IGtbNpm58OP84mjD6CUhIv8XS5QJdX395ijYsxDQAMHQYEepCCCQG0HTLYja0FtqTeB6W7Tswizo00iE8lMfnV',
  domain: 'demo.figalaxy.com',
  centralDomain: '',
  showExportFeature: true,
  showImportFeature: true,
  fiGalaxyUrl: 'https://fi-galaxy.ademo.net',
  firebaseConfig: {
    apiKey: 'AIzaSyArDF2GJjsZ5cQdYblnyLKYEpG39mJq0F4',
    authDomain: 'for-test-463b1.firebaseapp.com',
    projectId: 'for-test-463b1',
    storageBucket: 'for-test-463b1.appspot.com',
    messagingSenderId: '839282576119',
    appId: '1:839282576119:web:8ca5a8133a8f881a94e1f2',
  },
  vpaidKey:
    'BK4YtnCP-p-PU10FghMczlEOWG33AH3RCch1eURJfObWsG1SdcYUMJsz0TgrfAkR7TDKomMx0claUbZPWA7m4Gc',
  apiKey_loqate: 'WN85-CY69-AG78-ND97',
  googleMapsApiKey: 'AIzaSyCNkPr8dqCwhW4lBT2oK3doCXDnTrkrcb8',
  recaptcha: {
    siteKey: '6LdRLeMoAAAAANnanNlZxGLRXwOszzdSSYMfssaw',
  },
  publicClaim: {
    claimPrefixCId: 0, // TODO: set by backend — id of prefix where title === 'C'
    claimAdjustorId: 8643,
  },
};
